<template>
  <div id="founders-content" v-if="page.founders" :class="[{'active': currentPage == 'founders-content' || pageIsAutoScrolling}, {'static': isAnimated}]">
    <div class="section">
      <div class="section__main reduced-width">
        <div class="content content_founders light-bg">
          <div class="founders">
            <div class="founder" v-for="person in persons.item" v-if="person.$is_founder">
              <div class="founder__photo" :style="`background-image: url(${person.background ? person.background.$src : '/f/dist/static/img/noimage.jpg'})`"></div>
              <div class="founder__info">
                <div class="founder__name animated-title" :class="{'animating': pageReady}">
                  <PageTitleContent :isActive="isActive()" :isAnimated="isAnimated" :class="{'static': isAnimated}" :titleValue="person.text.item.first_name"></PageTitleContent><PageTitleContent :isActive="isActive()" :isAnimated="isAnimated" :class="{'static': isAnimated}" :titleValue="person.text.item.last_name"></PageTitleContent>
                </div>
                <div class="founder__content" v-html="person.text.item.text_content"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageTitleContent from '@/components/PageTitleContent';

export default {
  name: 'foundersContent',
  data() {
    return {
      isAnimated: false,
    };
  },
  components: {
    PageTitleContent,
  },
  computed: mapGetters({
    lang: 'lang',
    page: 'page',
    pageReady: 'pageReady',
    currentPage: 'currentPage',
    pageIsAutoScrolling: 'pageIsAutoScrolling',
    persons: 'persons',
  }),
  watch: {
    lang() {
      this.getData();
    },
  },
  methods: {
    isActive() {
      const checkActive = this.currentPage === 'founders-content';
      const animationTime = 3500;
      if (!this.pageIsAutoScrolling) {
        setTimeout(() => {
          if (checkActive) {
            this.isAnimated = true;
          }
        }, animationTime);
      }
      return checkActive;
    },
    getData() {
      this.$store.dispatch('fetchPersons', { lang: this.lang, $http: this.$http });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #founders-content {
    .content {
      margin-bottom: 40px;
    }
  }

  .founder {
    position: relative;
    margin-left: -120px;

    &:after {
      content: '';
      clear: both;
      display: block;
    }

    &__photo {
      position: relative;
      float: left;
      left: -20px;
      opacity: 0;
      margin: 0;
      width: 50%;
      padding-bottom: 66.66%;
      max-width: 800px;
      max-height: 1200px;
      background-position: 0 0;
      background-repeat: none;
      background-size: cover;
      transition: left 0.3s ease 0.3s, opacity 0.3s ease 0.3s;

      .active &,
      .static & {
        left: 0;
        opacity: 1;
      }

      .static & {
        transition: none;
      }
    }

    &__info {
      padding-top: 80px;
      margin-left: 55%;
      margin-bottom: 80px;
    }

    &__name {
      font-family: 'DietDidotTitleBold';
      font-size: 90px;
      line-height: 97px;

      & > span {
        margin-right: 25px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    &__position {
      margin-bottom: 30px;
      position: relative;
      left: -20px;
      opacity: 0;
      transition: left 0.3s ease 0.3s, opacity 0.3s ease 0.3s;

      .active &,
      .static & {
        left: 0;
        opacity: 1;
      }

      .static & {
        transition: none;
      }
    }

    &__content {
      position: relative;
      left: -20px;
      opacity: 0;
      transition: left 0.3s ease 0.6s, opacity 0.3s ease 0.6s;

      .active &,
      .static & {
        left: 0;
        opacity: 1;
      }

      .static & {
        transition: none;
      }

    }

    &:first-child {
      margin-top: -110px;
    }

    &:last-child {
      margin-bottom: -110px;
    }

    &:nth-child(2n+2) {
      margin-left: 0;
      margin-right: -120px;

      .founder {
        &__photo {
          float: right;
        }

        &__info {
          margin-right: 55%;
          margin-left: 0;
        }
      }
    }
  }

  @media (max-width: 850px) {
    #founders-content {
      .content {
        margin-bottom: 0;
      }
    }

    .founder {
      margin-left: 0;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;

        .founder {
          &__info {
            margin-bottom: 0;
          }
        }
      }

      &__photo {
        float: none;
        width: 100%;
        padding-bottom: 100%;
        margin-bottom: 30px;
      }

      &__info {
        padding-top: 0;
        margin-left: 0;
      }

      &__name {
        font-size: 18px;
        line-height: 150%;
        font-family: 'UniversLTStdBold';

        & > span {
          margin-right: 0;
        }

        .decor-line {
          display: none;
        }
      }

      &:nth-child(2n+2) {
        margin-right: 0;

        .founder {
          &__photo {
            float: none;
          }

          &__info {
            margin-right: 0;
          }
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/pages/FoundersContent.vue?462d26dc